/**
 * Supports placement of overlay regions on top of the printed design to indicate where post office might
 * place labels for the recipient or sender's address information.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 * The unauthorized use of this code outside the boundaries of Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define([], function() {
    return {
        selectorClassName: null,

        defaultOptions: {},

        /**
         * @param {DesignFacePreviewModel} model
         * @param $target
         * @param {number} face
         */
        render: function(model, $target, face) {},

        destroy: function($target) {
            $target.find('.' + this.selectorClassName).remove();
        },

        hide: function($target) {
            $target.find('.' + this.selectorClassName).hide();
        },

        show: function($target) {
            $target.find('.' + this.selectorClassName).show();
        }
    };
});
